import { ODataStoreRequestConfiguration } from '@/auth/api/config'
import { ordine } from '@/model/qsadminapi/QsAdminApiModuleModel'
import ODataStore from 'devextreme/data/odata/store'
import notify from 'devextreme/ui/notify'
import { useRef } from 'react'
import {
  Column,
  DataGrid,
  StateStoring,
  DataGridTypes,
  DataGridRef,
  Pager,
  Toolbar,
  Item,
  FilterRow,
  HeaderFilter,
  Scrolling,
  ColumnChooser,
} from 'devextreme-react/data-grid'
import { RowDblClickEvent } from 'devextreme/ui/data_grid'
import { useTokenRefresh } from '@/auth/azure/azureManager'
import DateColumn from '@/components/date-column/DateColumn'
import { gridTotalItemsLabel } from '@/constants'
import { StatoOrdine } from '@/routes/orders/order.types'
import { ObjectCodeLink } from '@/components/object-code-link/ObjectCodeLink'
import { ClickEvent } from 'devextreme/ui/button'
import { useScreenSize } from '@/themes/media-query'

const OrdersToProcessCard = () => {
  const token = useTokenRefresh()
  const gridRef = useRef<DataGridRef>(null)
  const currentScreenSize = useScreenSize()
  const ordersDataSource = {
    store: new ODataStore({
      url: `${import.meta.env.VITE_QSADMINAPI_HOST}/ordine`,
      key: 'id',
      keyType: 'Int32',
      version: 4,
      errorHandler: (e) => {
        console.error(e.errorDetails)
        if (!e.errorDetails) return
        notify(
          {
            message: `Errore : ${e.errorDetails?.message}`,
            type: 'error',
            displayTime: 5000,
          },
          {
            position: 'bottom center',
            direction: 'up-push',
          },
        )
      },
      beforeSend: ODataStoreRequestConfiguration(token),
      deserializeDates: false,
    }),
    expand: ['commessa($expand=sede($expand=azienda))'],
    filter: [['stato/nome', StatoOrdine.DA_EVADERE]],
    requireTotalCount: true,
  }

  return (
    <>
      <DataGrid
        id={`dashboard-orders-to-process-datagrid`}
        dataSource={ordersDataSource}
        ref={gridRef}
        noDataText="Nessun ordine da evadere"
        showBorders={true}
        showColumnLines={true}
        focusedRowEnabled={true}
        columnHidingEnabled={currentScreenSize.isSmall || currentScreenSize.isXSmall || currentScreenSize.isMedium}
        rowAlternationEnabled={true}
        wordWrapEnabled={false}
        repaintChangesOnly={true}
        width="100%"
        height={'40vh'}
        onRowDblClick={(e: RowDblClickEvent<any, any>) => {
          if (e.rowType === 'data') window.open(`/orders/${e.data.id}`, '_blank')
        }}
        allowColumnResizing={currentScreenSize.isLarge || currentScreenSize.isMedium}
        allowColumnReordering={currentScreenSize.isLarge || currentScreenSize.isMedium}
      >
        <ColumnChooser enabled={true} />
        <Scrolling mode="virtual"></Scrolling>
        <HeaderFilter visible={true}></HeaderFilter>
        <FilterRow visible={true}></FilterRow>
        <Pager
          visible={true}
          allowedPageSizes={'auto'}
          displayMode={'compact'}
          showPageSizeSelector={false}
          showInfo={true}
          showNavigationButtons={false}
          infoText={gridTotalItemsLabel}
        />
        <StateStoring
          enabled={true}
          type="localStorage"
          storageKey={'dashboard-orders-to-process-datagrid'}
          savingTimeout={50}
        />
        <Column visible={false} type="buttons" alignment="left" showInColumnChooser={false}></Column>
        <Column dataField={'id'} caption="ID" visible={false} dataType="number" defaultSortOrder="desc"></Column>
        <Column
          dataField="ded_Dis"
          cellRender={(cellData: DataGridTypes.ColumnCellTemplateData) => {
            const data: ordine = cellData.row.data
            return <ObjectCodeLink url={`/orders/${data.id}`} text={data.ded_Dis}></ObjectCodeLink>
          }}
          visible={true}
          caption="CODICE"
        ></Column>
        <Column
          dataField="commessa.sede.azienda.nome"
          cellRender={(cellData: DataGridTypes.ColumnCellTemplateData) => {
            const data: ordine = cellData.row.data
            return (
              <ObjectCodeLink
                url={`/clients/${data.commessa?.sede?.azienda?.id}`}
                text={data.commessa?.sede?.azienda?.nome}
              ></ObjectCodeLink>
            )
          }}
          caption="AZIENDA"
          visible={true}
        ></Column>
        {DateColumn({
          dataField: 'creazione',
          caption: 'DATA',
          format: 'dd/MM/yyyy',
        })}
        <Column dataField="importo" dataType="number" caption="IMPORTO"></Column>
        <Toolbar>
          <Item
            location="before"
            locateInMenu="never"
            showText="inMenu"
            widget="dxButton"
            options={{
              hint: 'Refresh',
              text: 'Refresh',
              icon: 'refresh',
              onClick: (e: ClickEvent) => {
                gridRef.current?.instance().refresh()
              },
              stylingMode: 'text',
            }}
          ></Item>
          <Item
            location="before"
            locateInMenu="never"
            showText="inMenu"
            widget="dxButton"
            options={{
              hint: 'Vai a ordini',
              text: 'Vai a ordini',
              icon: 'arrowright',
              onClick: (e: ClickEvent) => {
                window.open('/orders', '_blank')
              },
              stylingMode: 'text',
            }}
          ></Item>
          <Item
            name="columnChooserButton"
            locateInMenu="never"
            showText="inMenu"
            options={{ hint: 'Scelta colonne', text: 'Scelta colonne' }}
          />
        </Toolbar>
      </DataGrid>
    </>
  )
}

export default OrdersToProcessCard
